<template>
    <div class="component html">
        <template v-if="sources">
            <div v-for="source in sources" v-html="variableSwapWithSource(content, source)"></div>
        </template>
        <template v-else="">
            <div v-html="content"></div>
        </template>
    </div>
</template>

<script type="text/babel">
    import {VCheckbox} from 'vuetify/lib'
    import StringService from '@/services/string'
    import TextReplacement from "@/mixins/textReplacement";

    export default {
        name: 'components-json_page-components-html',
        watch: {
            value() {
                this.newValue = this.value;
            }
        },
        props: {
            sources: undefined,
            content: undefined,
            id: undefined
        },
        data() {
            return {
                newValue: undefined
            }
        },
        methods: {
            variableSwapWithSource(content, source) {
                return StringService.stringVariableSwap(content, source);
            }
        },
        computed: {},
        created() {

        },
        mounted() {
          this.dataDollarReplacement(this.$el);
        },
        beforeDestroy() {
        },
        mixins: [
            TextReplacement
        ],
        components: {
            VCheckbox
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
